/* eslint-disable max-classes-per-file */
/* eslint-disable no-this-before-super */
/* eslint-disable no-undef */
/* eslint-disable no-plusplus */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
import "phaser";
import { Entity } from './Entity'
import { loadSpritesheet, createAnimation } from "./../modules/utiltes"
import { SoundManager } from "../ScenesHelpers/SoundManager";
export class Player extends Entity {
    /** 
     * Player constructor @param {object} scene -scene that Player object belongs to- @param {number} x - value of Player on x axis - @param {number} y - value of Player on y axis - @param {String} key -contains key of Player-  @param {String} type -contains type of Player-  @param {number} speed -contains speed  of Player  - @param {number} level -contains level of  Player  - @param {number}maxcapacity -number of shoots that spaceship can carry it-  @param {number}maxfuel -amount of fuel that spaceship can carry it- @param {number}resilience -number of hits can spaceship take it before destruction-
     * setter and getter function for  -maxfuel ,  max capacity ,currentScore ,highScore-
     * consumeFuel function : -decrease amount of fuel during the game-
     * isMoving function :- check if player is moving or not-
     *  moveDown ,moveUp ,moveLeft ,moveRight functions : controle direction of the game
     *  moveDownStop ,moveDownStop ,moveDownStop ,moveDownStop functions : stop spaceship in specific direction
     * */
    constructor(
        scene,
        x,
        y,
        key,
        type,
        level,
        speed,
        scalex,
        scaley,
        maxcapacity,
        maxfuel,
        resilience
    ) {
        super(scene, x, y, key, type);
        this.key = key;
        this.level = level;
        this.scaleX = scalex;
        this.scaley = scaley;
        this.capacity = 0;
        this.setDepth(1);
        this.maxcapacity = maxcapacity;
        this.setfuel(maxfuel);
        this.setData("resilience", resilience)
        this.setData("speed", speed);
        this.setData("timerShootDelay", 10);
        this.setData("timerShootTick", this.getData("timerShootDelay") - 1);
    }
    static loadAssets(scene, key, framex, framey, keylink) {
        loadSpritesheet(scene, key, keylink, framex, framey)
    }
    static loadAnime(scene, key, framex) {
        createAnimation(scene, `${key}`, framex, -1)
    }
    getMaxCapacity() {
        return this.maxcapacity;
    }
    setfuel(fuel) {
        this.fuel = fuel;
    }
    getfuel() {
        return this.fuel;
    }

    isMoving() {
        return this.body.velocity.x !== 0 || this.body.velocity.y !== 0;
    }

    consumeFuel() {
        //make delay for fuel consumption every 1 second
        if (this.getfuel() > 0 && this.isMoving() && !this.getData("isDead")) {
            this.setfuel(this.getfuel() - 1);
        }
    }

    moveUp() {
        this.body.velocity.y = -this.getData("speed");
        this.consumeFuel();
    }

    moveDown() {
        this.body.velocity.y = this.getData("speed");
        this.consumeFuel();
    }

    moveLeft() {
        this.body.velocity.x = -this.getData("speed");
        this.consumeFuel();
    }

    moveRight() {
        this.body.velocity.x = this.getData("speed");
        this.consumeFuel();
    }
    moveStop() {
        this.body.velocity.x = 0;
        this.body.velocity.y = 0;
    }

    moveUpStop() {
        this.body.velocity.y = 0;
    }
    moveDownStop() {
        this.body.velocity.y = 0;
    }
    moveLeftStop() {
        this.body.velocity.x = 0;
    }
    moveRightStop() {
        this.body.velocity.x = 0;
    }

    onDestroy(mode) {
        this.mode = mode;
        this.scene.time.addEvent({
            // go to game over scene
            delay: 100,
            callback() {
                this.scene.scene.start("SceneScores", { isDead: true, player: this, mode: this.mode });
            },
            callbackScope: this,
            loop: false,
        });
    }
    setCurrentPlayerScore(score) {
        this.score = score
    }
    getCurrentPlayerScore() {
        return this.score
    }
    setPlayerHighScore(highscore) {
        this.highscore = highscore
    }
    getPlayerHighScore() {
        return this.highscore
    }
    update() {
        this.body.setVelocity(0, 0);
        this.x = Phaser.Math.Clamp(this.x, 0, this.scene.game.config.width);
        this.y = Phaser.Math.Clamp(this.y, 0, this.scene.game.config.height - 210);
    }
}